import { render } from "./DataTableRowHandler.vue?vue&type=template&id=1df4081c&scoped=true"
import script from "./DataTableRowHandler.vue?vue&type=script&lang=js"
export * from "./DataTableRowHandler.vue?vue&type=script&lang=js"

import "./DataTableRowHandler.vue?vue&type=style&index=0&id=1df4081c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df4081c"]])

export default __exports__